export const NAVIGATION_BAR_STYLE = {
  DRAK: 0,
  LIGHT: 1,
};

export const DATE_UNIT = {
  MONTH: 4,
  DAY: 3,
  HOUR: 2,
  MINUTE: 1,
  SECOND: 0,
};

export const MEDIA_TYPE = {
  IMAGE: 0, //图片
  VIDEO: 1, //视频
};

/**
 * 奖品类型
 */
export const AWARD_TYPE = {
  COINS: 0, //金币
  VIP: 1, //vip
  THEME: 2, //主题
  AVATAR_FRAME: 3, //头像框
  CAR: 4, //座驾
  EXP: 5, //经验值
  DIAMOND: 6, //钻石
  VIP1: 7, //VIP1
  VIP2: 8, //VIP2
  VIP3: 9, //VIP3
  VIP4: 10, //VIP4
  GOOD_ID: 12, //靓号
  GIFT: 13, //礼物
  INTIMACY:14,
  RING:16, //戒指
  MEDAL: 20, //勋章
  BLUE_DIAMOND: 25, //蓝钻
  RED_DIAMOND: 26, //红钻
  SVIP: 27, //SVIP
  TOKEN: 28, //游戏棋子皮肤
  GAME_THEME: 29, //游戏主题
  USER_HALL_FAME_TAG:31,//名人堂标签
  REBATE_RATIO: 32, //分成比例
  LUDOSVIP: 37, //LUDOSVIP
  TICKET: 36,//抽奖券
  TICKET_LUDO: 47,//抽奖券
}
/**
 * 商品类型
 */
export const GOODS_TYPE = {
  THEME: 0,
  AVATAR_FRAME: 1,
  CAR: 2,
  CUSTOM_THEME: 3,
  RING: 4,
  COINS: 5,
  VIP1: 6,
  VIP2: 7,
  VIP3: 8,
  VIP4: 9,
};

export const ROOM_GLOBAL_CONFIG_TYPE = {
  GLOBAL_ROOM_TEAM_SUPPORT: 24, //房间守护的球队,当数值为空时，表示房间未选择守护的球队,该属性值不允许修改
  GLOBAL_2022_WORLDCUP_TOP8_TEAMS: 25, //2022世界杯8强球队,房间全局配置
  GLOBAL_APPROVING_VERSION: 28, //提审版本信息
};

export const FROM_SCENE = {
  IN_ROOM: 0, //房间内场景
  CHAT_MATCH: 1, //1V1匹配场景
  VOICE_MATCH: 2, //语音匹配场景
  COMMON_IM: 3, //普通IM私信场景
  QUICK_SAY_HI: 4, //IM快捷问好
  STARTUP: 5, //app启动
  CHARGE: 6, //支付
  HIGH_POTENTIAL_CHAT: 7, //私信高潜力用户
  ACTIVITY_IM_NOTIFY_FANS: 8, //活动广场中活动通知粉丝
  INITIATIVE_FOLLOW: 9, //用户主动关注
  RECOMMEND_FOLLOW: 10, //用户从推荐关注
  INITIATIVE_ROOM_TEXT: 11, //用户主动发送公屏
  MERCHANT_LIST: 15, //币商列表
  GALA: 16, //年度盛典
  INVITE_JOIN_GROUP: 38,//拉新加团关注团长 inchat
  NEW_USER_INVITER: 39,//新用户邀请关注邀请者 inchat
  GLOBAL_SUPPORT_MERCHANT: 53,//支持币商分账户的大区
};

export const FOLLOW_OP_TYPE = {
  UN_FOLLOW: 0, //取消关注
  FOLLOW: 1, //关注
};

/**
 * 主播消息类型
 */
export const AnchorMessageType = {
  MESSAGE_WORLDCUP_COIN_CARVEUP_REWARD: 10, //世界杯助威榜金币瓜分
};

/**
 * 模板消息类型
 */
export const AnchorMessageTemplateType = {
  NON: 0,
  NORMAL: 1,
  RADIO: 2,
};

export const BOARD_ITEM_TYPE = {
  user: 0, //参与榜单排名的是用户ID
  room: 1, //参与榜单排名的是房间ID
  family: 2, //参与榜单排名的是家族
};

export const ACTIVITY_CODE = {
  FAMILY_PK_YEARLY: 18, //年度家族争霸
  FAMILY_BOARD: 19, //家族榜单活动
  PK_VICOTRY_BOARD: 21,//PK皇室战争Victory榜
  PK_MVP_BOARD: 22,//PK皇室战争MVP榜
  WEEKLY_BILLIONARIRES_BOARD: 23, //周星榜富豪榜
  WEEKLY_SUPER_STARS_BOARD: 24, //周星榜超级明星榜
  WEEKLY_BILLIONARIRES_BOARD_DE: 25, //周星榜富豪榜
  WEEKLY_SUPER_STARS_BOARD_DE: 26, //周星榜超级明星榜
  FRUIT_WINNER_CONTEST: 33,//水果机赢家榜单
  FRUIT_WINNER_CONTEST_DE: 34,//水果机赢家榜单Wyak DE区
  FRUIT_WINNER_CONTEST_LUDO: 51,//水果机赢家榜单Lama ludo
  WEEKLY_BILLIONARIRES_BOARD_TR: 39, //周星榜富豪榜
  WEEKLY_SUPER_STARS_BOARD_TR: 40, //周星榜超级明星榜
  WEEKLY_BILLIONARIRES_BOARD_EG2: 41, //周星榜富豪榜
  WEEKLY_SUPER_STARS_BOARD_EG2: 42, //周星榜超级明星榜
  WEEKLY_BILLIONARIRES_BOARD_TH: 43, //周星榜富豪榜
  WEEKLY_SUPER_STARS_BOARD_TH: 44, //周星榜超级明星榜
  WEEKLY_BILLIONARIRES_BOARD_VN: 45, //周星榜富豪榜
  WEEKLY_SUPER_STARS_BOARD_VN: 46, //周星榜超级明星榜
  WEEKLY_BILLIONARIRES_BOARD_BD: 47, //周星榜富豪榜
  WEEKLY_SUPER_STARS_BOARD_BD: 48, //周星榜超级明星榜
  SUPPORTER_CONTEST: 40, // lama拉新榜单
  FAMILY_DAILY_TASK: 58, //家族每日任务
  FAMILY_MONTHLY_TASK_BOARD: 59, //家族每月任务榜
  FAMILY_MEMBER_GIFTCOINS_BD: 60, //家族成员送礼榜
  FAMILY_MEMBER_RECEIVED_BD: 61,  //家族成员收礼榜
  FAMILY_MEMBER_ROOMCOINS_BD: 62, //家族房间金币流水榜
  MONTHLY_CONSUMPTION_NEW_USER: 107, //月度消费新用户
  MONTHLY_CONSUMPTION: 108, //月度消费
  MONTHLY_CONSUMPTION_NEW_USER_ACTIVITY_CODE: 1000107,//月度消费新用户活动码
  MONTHLY_CONSUMPTION_ALL_ACTIVITY_CODE: 1000108,//月度消费活动码
};

export const REWARD_STATUS = {
  NO: 0, //没有该奖励的领取权限
  AVAILABLE: 1, //奖励可领取
  TAKEN: 2, //奖励已经被领取
};

export const GLOBAL_CONFIG_TYPE = {
  GLOBAL_LUCKYGIFT_SHARING_PERCENT: 27, //幸运礼物金币分成
  GLOBAL_ROOM_WEDDING_BLESSING_CONFIG: 50, //婚礼房送礼祝福值
  GLOBAL_ROOM_WEDDING_BLESSING_CONFIG_LUDO: 45, //婚礼房送礼祝福值
};

export const USER_COMMON_CONFIG_TYPE = {
  AVATAR_FRAME: 0, //头像框
  USER_INVISIBLE_JOIN_LAMA: 13, //Lama隐身进房
  USER_INVISIBLE_JOIN_WYAK: 16,//Wyak隐身进房
};

export const PLATFORM = {
  ANDROID: "android",
  IOS: "ios",
};

export const PACKAGE_NAME = {
  ANDROID_LAMA: "com.wenext.lama",
  ANDROID_LAMA_LITE: "com.wenext.voice",
};

export const APP_CHANNEL = {
  GP: "gp", //gp渠道，通过gp下载
  GOOGLE_PLAY: "google-play", //google-play渠道，通过gp下载
  HUAWEI: "huawei", //华为渠道，通过华为应用商店下载
  LUOKAI: "luokai", //洛凯渠道，洛凯渠道下载
  GOOGLE: "google", //google推广渠道，通过gp下载
  FB: "fb", //fb推广渠道，通过gp下载
  HUITENG: "huiteng", //辉腾渠道
  APPLE_STORE: "apple_store", //苹果商店渠道
};

export const SCORE_TYPE = {
  COIN: 0, //金币
  DIAMOND: 1, //钻石
};

export const REGION = {
  EG: "EG", //中东一区
  EG_2: "EG_2", //中东二区区
  DE: "DE", //其他区
  IN: "IN", //印度
  TR: "TR", //土耳其
  TH: "TH", //泰国
  CN: "CN",//中国区
  VN: "VN",//越南区
  BD: "BD",//孟加拉区
};

export const REGION_TO_UTC_OFFSET = {
  "EG": 2,
  "EG_2": 2,
  "DE": 5.5,
  "IN": 5.5,
  "TR": 3,
  "TH": 7,
  "CN": 8,
  "VN": 7,
  "BD": 6
}

/**
* 音效类型
*/
export const SoundType = {
  SOUND: 0, //短音效
  MUSIC: 1 //长音效
}

export const SOUND_LOOP_INFINITE = -1 // 无限循环

/**
 * 币商账户金币类型
 */
export const MERCHANT_COIN_TYPE = {
  COIN: 0,
  MERCHANT_COIN: 7,
};
